import { render, staticRenderFns } from "./TicketCommentsPage.vue?vue&type=template&id=0ddf5416"
import script from "./TicketCommentsPage.vue?vue&type=script&lang=js"
export * from "./TicketCommentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports